import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { DiagnosticOrderActionsService } from '../../services/diagnostic-order-actions.service';
import { IDiagnosticOrder, IRevision } from '../../interfaces/diagnostic-order.interface';
import { Subject } from 'rxjs/Subject';
import { TestSummaryActionsService } from '../../services/test-summary-actions.service';
import { DynamicModalLoaderService } from '../../../../layout/services/dynamic-modal-loader.service';
import { ConfirmModalComponent } from '../../../../layout/components/modals/confirm-modal/confirm-modal.component';
import { modalResponse } from '../../../../layout/constants/modal-responses.enum';
import { CoreActionCreatorService } from '../../../../core/services/core-action-creator.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { InterpreationSummary } from '../../interfaces/interpreation-summary.interface';
import { HttpInterceptorService } from '../../../../core/services/http-interceptor.service';
import { QcService } from '../../../../quality-check/services/qc.service';
import { RelatedControlTest } from '../../../../quality-check/components/qc-results/qc-results.component';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { UICustomizationService } from '../../../../shared/services/ui-customization.service';
import { TestService } from '../../services/test.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-test-summary',
  templateUrl: './test-summary.component.html',
  styleUrls: ['./test-summary.component.scss'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestSummaryComponent implements OnInit, OnDestroy {
  maxInterpetationTextLength = 30000;
  currentUser;
  currentUserRole: string;
  // enableAddendumInput: boolean;
  enableAddendumInput$: Observable<boolean>;
  // interpretationText: string;
  // addendumText: string;
  currentTest: IDiagnosticOrder;
  currentRevision: IRevision;
  qcConfig: any;
  conclusions: Array<InterpreationSummary>;

  interpretationTextControl = new FormControl('');
  addendumTextControl = new FormControl('');

  private revisionId: string;
  private forceEnableAddendum$: Subject<boolean> = new Subject();
  private destroyed$: Subject<any> = new Subject();
  private resultStatus: string;
  private readonly baseUrl = '/Report';
  private readonly textInputDebounce = 300;

  @ViewChild('#content-div', {static: false}) private contentDiv: ElementRef;
  private controlSampleStatus: any;


  constructor(private authService: AuthenticationService, private diagnosticOrderActionsService: DiagnosticOrderActionsService, private testSummaryActionsService: TestSummaryActionsService,
              private cd: ChangeDetectorRef, private testService : TestService,
              private notificationMessageService: NotificationMessageService,
              private dynamicModalLoader: DynamicModalLoaderService,
              private workflowService: WorkflowService,
              private coreActions: CoreActionCreatorService, private datePipe: DatePipe, private http: HttpInterceptorService,
              private qcService: QcService, private uiCustomisationService: UICustomizationService,
              private routerManagerService: RouterManagerService) {
  }

  ngOnInit() {
    this.revisionId = this.routerManagerService.parameters.revisionId;
    const currentUser = this.authService.user;
    this.qcConfig = this.testService.testConfiguration.qcConfig;
    this.currentUser = currentUser ? (currentUser.info ? currentUser.info.id : null) : null;
    this.currentUserRole = currentUser ? currentUser.role : null;
    this.loadInterpretationSummary();
    this.loadControlSampleStatusesConfig();
    this.enableAddendumInput$ = this.addendumTextControl.valueChanges
      .debounceTime(this.textInputDebounce).map(value => !!value)
      .merge(this.forceEnableAddendum$);
    this.diagnosticOrderActionsService.getState()
      .filter(state => !!state.order && Object.keys(state.order).length > 0)
      .map(state => state.order)
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(order => {
        this.currentTest = order;
        this.currentRevision = order.workflowRequest.revisions.find(rev => rev.id === this.revisionId);
        this.cd.markForCheck();
      });
    // this.currentRevision$ = this.currentTest$.map(test =>
    //   test.workflowRequest.revisions.find(rev => rev.id === this.revisionId));
    this.testSummaryActionsService.storedReview$(this.revisionId)
      .subscribe(reviews => {
        this.interpretationTextControl.reset(reviews.get('finalReview'));
        this.addendumTextControl.reset(reviews.get('finalReview'));
        // this.enableAddendumInput = !!this.addendumTextControl.value;
        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  hasQcConfig() {
    return this.testService.testConfiguration ? this.testService.testConfiguration.qcConfig != undefined : false;
  }

  isQcTest() {
    return this.testService.isNavicanControlSample();
  }

  // displayAddendumInput() {
  //   this.enableAddendumInput = !!this.addendumText;
  // }
  displayAddendumInput() {
    this.forceEnableAddendum$.next(true);
    this.moveScrollToBottom();
  }

  enableFor(statusName: string) {
    switch (statusName) {
      case 'interpretation':
        return this.currentUser === this.currentTest.performer
          && ['final review', 'interpretation results', 'signoff'].indexOf(this.currentRevision.status.toLowerCase()) !== -1
          && !this.isTestFailed();
      case 'completed':
        return ['final review', 'test completed', 'signoff'].indexOf(this.currentRevision.status.toLowerCase()) !== -1;
      case 'allowed':
        return this.currentUser === this.currentTest.performer && this.currentRevision.status.toLowerCase() === 'test completed';
      case 'test_completed':
        return this.currentRevision.status.toLowerCase() === 'test completed';
    }
  }

  private isTestFailed(): boolean {
    return ['failed'].indexOf(this.currentRevision.status.toLowerCase()) > -1;
  }

  updateReview(reviewText: string, fileType: string) {
    this.testSummaryActionsService.setReview(fileType, this.revisionId, reviewText);
  }

  releaseFinalReport(): void {
    this.performWorkflowStep('Are you sure you want to release final report?', 'final report');
  }

  submitQcTest() {
    if (!this.resultStatus) {
      this.notificationMessageService.error('QC state is not selected');
      return;
    }
    this.performWorkflowStep('Are you sure you want to submit test?', 'setTestStatus', this.resultStatus);
  }

  getResultStatus(): string {
    return this.currentTest.resultStatus ? this.currentTest.resultStatus : '';
  }

  getTranslationKey(text: string): string {
    return `testSummary.interpretation.${text}`;
  }

  releaseAddendumReport(): void {
    const confirmDialog$ = this.dynamicModalLoader.popupModal(ConfirmModalComponent, {
      title: 'Release Addendum Report?',
      content: '',
      approveBtn: 'OK',
      declineBtn: 'Cancel'
    });

    confirmDialog$.map(response => response.payload)
      .filter(response => response > 0)
      .take(1)
      .filter((response: modalResponse) => response === modalResponse.approve)
      .switchMap(() => this.http.post(this.baseUrl + '/releaseAddendumReport', this.buildAddendumObject(), true))
      .subscribe(() => {
        this.testSummaryActionsService.initReview(this.revisionId);
        this.addendumTextControl.reset('');
        this.cd.markForCheck();
        // this.state.reload();
      }, (err: HttpErrorResponse) => {
        if (err.status === 403) {
          this.notificationMessageService.error('unable to release addendum report');
        }
      });
  }

  onQcOptionSelected($event: { display: string; code: string }) {
    console.debug('[testSummaryCtrl.onQcOptionSelected ] selected result=' + $event.code);
    const foundResult = this.qcConfig.options.find(el => {
      return $event.code === el.code;
    });
    this.resultStatus = foundResult ? foundResult.display : '';
  }

  private performWorkflowStep(dialogTitle: string, workflowStep: string, buttonInputArgs?: any) {
    const confirmDialog$ = this.dynamicModalLoader.popupModal(ConfirmModalComponent, {
      title: dialogTitle,
      content: '',
      approveBtn: 'OK',
      declineBtn: 'Cancel'
    });

    confirmDialog$.map(response => response.payload)
      .filter(response => response > 0)
      .take(1)
      .filter((response: modalResponse) => response === modalResponse.approve)
      .subscribe(() => {
        this.currentTest.localDateTime = this.testService.getLocalDateTime();
        this.coreActions.setLoader(true);
        this.workflowService.performWorkflowStep(this.currentTest, workflowStep, '', this.currentRevision.id,
          this.currentTest.workflowRequest.id, this.interpretationTextControl.value, buttonInputArgs)
          .then(() => {
              this.testSummaryActionsService.initReview(this.revisionId);
              this.coreActions.setLoader(false);
            this.routerManagerService.reload();
          })
          .catch(() => {
            this.notificationMessageService.error('unable to submit test');
            this.coreActions.setLoader(false);
          });
      });
  }

  private buildAddendumObject() {
    return {
      revisionId: this.currentRevision.id,
      workflowId: this.currentTest.workflowRequest.id,
      updateText: this.addendumTextControl.value,
      clientDate: this.datePipe.transform(new Date(), 'dd MMM yyyy'),
      userId: this.currentUser,
      testNumber: this.currentTest.workflowRequest.testNumber
    };
  }

  private loadInterpretationSummary() {
    this.coreActions.setLoader(true);

    // this.testSummaryActionsService.loadInterpretationSummary(this.currentRevision.id);
    this.http.get<InterpreationSummary[]>(this.baseUrl + '/getInterpretationSummary', { params: { revisionId: this.revisionId}})
      .map(response => response.body)
      .filter(response => Array.isArray(response.length))
      .subscribe(summaries => this.testSummaryActionsService.initInterpretationSummaries(summaries));
    this.testSummaryActionsService.interpreationSummaries$
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(conclusions => {
        this.conclusions = conclusions;
        if (!!this.addendumTextControl.value) { this.moveScrollToBottom(); }
        // this.cd.detectChanges();
      });
  }

  private moveScrollToBottom() {
    const element = this.contentDiv.nativeElement;
    element[0].scrollTop = element[0].scrollHeight - element[0].offsetTop;
  }

  private loadControlSampleStatusesConfig() {
    this.coreActions.setLoader(true);
    this.http.get('valueset/getNavicanControlTestStatuses', { }, true) // TODO: Move this to a service, maybe qc service or something who knows
      .subscribe((returnedValueSet) => {
        this.controlSampleStatus = returnedValueSet.body;
      });
  }

  private showWarningAndReleaseFinalReport() {
    const qcWarningConfig = this.testService.testConfiguration.qcWarningConfig;
    if (!qcWarningConfig) {
      this.releaseFinalReport();
    } else {
      this.coreActions.setLoader(true);
      this.qcService.getRelatedQCTests(this.currentTest.workflowRequest.id, this.testService.testConfiguration.testType)
        .subscribe((relatedTests: RelatedControlTest[]) => {
            this.coreActions.setLoader(false);
            const showWarning = relatedTests && relatedTests.length > 0 ? this.analyseRelatedControlTestStatus(relatedTests[0]) : false;
            if (showWarning) {
              this.dynamicModalLoader.popupModal(ConfirmModalComponent,
                {
                  title: qcWarningConfig.title,
                  content: qcWarningConfig.content,
                  approveBtn: qcWarningConfig.approveBtn,
                  declineBtn: qcWarningConfig.declineBtn
                }, qcWarningConfig.dialogType).subscribe((response) => {
                if (response.payload === 1) {
                  this.releaseFinalReport();
                }
              });
            }
            else {
              this.releaseFinalReport();
            }
          }
        );
    }
  }

  private analyseRelatedControlTestStatus(relatedTest: RelatedControlTest) {
    if (this.controlSampleStatus && relatedTest.orders && relatedTest.orders.length > 0) {
      return relatedTest.orders.some(order => order.resultStatus && order.resultStatus !== this.controlSampleStatus[0].display);
    }
    return false;
  }

  prepareClassName(): string {
    const tagValue = this.currentTest.resultStatus ? this.currentTest.resultStatus : '';
    return tagValue ? tagValue.toLowerCase().replace(' ', '_') : '';
  }

  canShowSummaryInput(): boolean {
    return this.uiCustomisationService.getUICustomResourceProperty('show-summary-input', 'visible')
      && (this.currentUser === (this.currentTest && this.currentTest.performer))
      && (this.currentRevision && this.currentRevision.status && ['test completed'].indexOf(this.currentRevision.status.toLowerCase()) !== -1)
      && !this.isQcTest();
  }
}
